import { render, staticRenderFns } from "./Shopify-integration.vue?vue&type=template&id=9fd09a08&"
import script from "./Shopify-integration.vue?vue&type=script&lang=js&"
export * from "./Shopify-integration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports